module.exports = __webpack_public_path__ + "img/dg-browse-vehicles-default-navy.f1b93911.png";